module.exports = __webpack_public_path__ + "img/im.52522de4.svg";